/**
 * Which booking steps paint FlightEngineShell.
 * selfComposePick stays an engine step — it has no preview screen.
 */

const SHELL_BY_STEP = {
  search: { step: "search", title: "חיפוש טיסות" },
  results: { step: "results", title: "תוצאות" },
  flightDetails: { step: "details", title: "פרטי טיסה" },
  passengers: { step: "passengers", title: "פרטי נוסעים" },
  extras: { step: "extras", title: "תוספות וכבודה" },
  review: { step: "review", title: "סיכום והזמנה" },
  holdConfirmation: { step: "confirmation", title: "אישור הזמנה" },
  draftPayment: { step: "payment", title: "תשלום" },
  success: { step: "confirmation", title: "אישור הזמנה" },
};

/**
 * @param {{ currentStep?: string, onResultsListUrl?: boolean, loading?: boolean }} input
 * @returns {{ step: string, title: string } | null}
 */
export function resolveFlightEngineShellStep({
  currentStep,
  onResultsListUrl = false,
  loading = false,
} = {}) {
  if (currentStep === "search" && (onResultsListUrl || loading)) {
    return SHELL_BY_STEP.results;
  }
  if (currentStep === "selfComposePick") return null;
  return SHELL_BY_STEP[currentStep] || null;
}
